import { render, staticRenderFns } from "./CustomerAgreementsForm.vue?vue&type=template&id=3921177f&"
import script from "./CustomerAgreementsForm.vue?vue&type=script&lang=js&"
export * from "./CustomerAgreementsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports